import { createContext } from 'react';

import { AppElementContextType } from './types';

const AppElementContext = createContext<AppElementContextType>(
  ({} as unknown) as AppElementContextType,
);

export default AppElementContext;
